module.exports = __webpack_public_path__ + "static/media/novice.65ec9f93.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/fanball/novice.png
// module id = 181
// module chunks = 0